import { render, staticRenderFns } from "./Tipotamponamento.vue?vue&type=template&id=f66439a2&scoped=true&"
import script from "./Tipotamponamento.vue?vue&type=script&lang=js&"
export * from "./Tipotamponamento.vue?vue&type=script&lang=js&"
import style0 from "./Tipotamponamento.vue?vue&type=style&index=0&id=f66439a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66439a2",
  null
  
)

export default component.exports